import { InjectedTypes } from "types/injector";

/**
 * Gets the list of items to inject, in order.
 * This is a function so we could programmatically change what it returns in the future.
 * For example, we could return a different list if isMobile or for an AB test.
 */
export default function getInjectionOrder(
  hasRecirc: boolean,
  hasBento: boolean,
  isMobile: boolean
): InjectedTypes[] {
  const injectionOrder = new Array(40).fill(InjectedTypes.Ad);

  // No house ad on mobile
  if (!isMobile) {
    injectionOrder[0] = InjectedTypes.House;
  }

  // only inject a recirc module if it doesn't already have a recirc module
  // and if it doesn't have a bento recirc module
  if (!hasRecirc && !hasBento) {
    injectionOrder[2] = InjectedTypes.Recirc;
  }
  return injectionOrder;
}
